//@ts-ignore
import { MergedGpEventResponse } from "gamePage/types";
import "./eventList.css";

interface EventItemDummyProps {
	event: MergedGpEventResponse;
}

export function EventItemDummy({event}: EventItemDummyProps) {
	return <div className="eventItem" data-start-time={event.startTime} data-end-time={event.endTime}></div>;
}
